import React from 'react';
import {TouchableOpacity, View} from 'react-native';

import Button from '../../../components/ui-controls/Button';
import Text from '../../../components/ui-controls/Text';
import {EnquireVoucherResponse, Transaction} from '../../../models/middleware';
import {centsToDollarsString} from '../../../utils/functions';

const ValueRow = ({label, value}: {label: string; value: string}) => (
  <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
    <Text variant="heading2">{label}</Text>
    <Text>{value}</Text>
  </View>
);

const renderTransaction = ({
  deltaAmount,
  date,
  sequence,
}: {
  deltaAmount: number;
  date: string;
  sequence: string;
}) => {
  // Convert date from "YYYY-MM-DD" to "DD/MM/YYYY"
  const formattedDate = date.split('-').reverse().join('/');

  const deltaAmountValueAbs = Math.abs(deltaAmount);
  const formattedDeltaAmountValue = centsToDollarsString(deltaAmountValueAbs);
  const plusOrMinus = deltaAmount >= 0 ? '+' : '-';

  return (
    <ValueRow
      key={sequence}
      label={formattedDate}
      value={`${plusOrMinus} $${formattedDeltaAmountValue}`}
    />
  );
};

const Transactions = ({transactions = []}: {transactions: Transaction[]}) => (
  <View style={{marginTop: 16}}>
    {transactions.length ? (
      <View>
        <Text style={{marginBottom: 16}}>
          Here is the transaction history for your gift card:
        </Text>
        {transactions.map(renderTransaction)}
      </View>
    ) : (
      <View>
        <Text>There are no transactions yet</Text>
      </View>
    )}
  </View>
);
type GiftCardBalanceViewProps = {
  giftCardData: EnquireVoucherResponse;
  onOk: () => void;
  onContactUs: () => void;
};
const GiftCardBalanceView = ({
  giftCardData,
  onOk,
  onContactUs,
}: GiftCardBalanceViewProps) => {
  const {voucher} = giftCardData;
  const transactions = voucher.transactions || [];

  const currentBalanceCents = voucher.balance;
  const formattedCurrentBalanceDollars =
    centsToDollarsString(currentBalanceCents);

  return (
    <View style={{marginTop: 16}}>
      <ValueRow
        label="Current balance"
        value={`$${formattedCurrentBalanceDollars}`}
      />
      <Transactions transactions={transactions} />
      <Text style={{marginTop: 16}}>
        if you have any questions relating to the balance or your transactions
        please contact us{' '}
        <TouchableOpacity onPress={onContactUs}>
          <Text style={{color: 'blue'}}>here</Text>
        </TouchableOpacity>
        .
      </Text>
      <Button title="OK" onPress={onOk} style={{marginTop: 16}} />
    </View>
  );
};

export default GiftCardBalanceView;
